import { render } from "./seo-assessor.vue?vue&type=template&id=57bab3dd"
import script from "./seo-assessor.vue?vue&type=script&lang=js"
export * from "./seo-assessor.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__